import { action as apiAction } from 'api/Api'

type Payload = {
  successorId: number
  name: string
  statusId: number
  groupId?: number
  position?: number
  template: any
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { name, successorId, statusId, groupId, position, template } = payload

  const args: any = {
    cardId: successorId,
    addCard: {
      name: name.trim(),
      statusId,
      template,
    },
  }

  if (statusId && getState()['view-board'].cards[successorId]?.statusId === statusId) {
    args.addCard.statusPosition = { above: successorId }
  }

  if (groupId) {
    args.groupTarget = {
      groupId,
      position,
    }
  }

  await apiAction('AddNewPrevCard', args)
}
